import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import notificationsService from './notificationsService';

// Helper to get the best available auth token
const getAuthToken = (getState) => {
  const state = getState();
  if (state.auth?.token) return state.auth.token;
  return localStorage.getItem('cleanStudioToken');
};

export const fetchNotifications = createAsyncThunk(
  'notifications/fetchNotifications',
  async ({ limit = 20 } = {}, { getState, rejectWithValue }) => {
    try {
      const token = getAuthToken(getState);
      const response = await notificationsService.listNotifications(token, { limit });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const markAllRead = createAsyncThunk(
  'notifications/markAllRead',
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getAuthToken(getState);
      await notificationsService.markRead(token);
      return {};
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    notifications: [],
    unreadCount: 0,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetchNotifications
      .addCase(fetchNotifications.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.notifications = action.payload.notifications || [];
        state.unreadCount = action.payload.unread_count || 0;
        state.error = null;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // markAllRead
      .addCase(markAllRead.fulfilled, (state) => {
        state.unreadCount = 0;
        state.notifications = state.notifications.map((n) => ({
          ...n,
          is_read: true,
        }));
      });
  },
});

export const selectNotifications = (state) => state.notifications.notifications;
export const selectUnreadCount = (state) => state.notifications.unreadCount;
export const selectNotificationsStatus = (state) => state.notifications.status;

export default notificationsSlice.reducer;
